<template>
  <div>
    <div class="section-heading">
      <div class="container">
        <h1 class="section heading__title">
          Negociaciones
        </h1>
      </div>
    </div>
    <we-tabs ref="tabs">
      <we-tab name="Activas" :selected="true">
        <offers-list
          :offers-states="['in_negotiation', 'published', 'accept_pending']"
          :storeDestiny="'publishedList'"
          :ref="'published'"
          :autoload="true"
          :filterType="'activeNegotiations'"
          :negotiations="true"
          :key="'publishedList'"
          >>
        </offers-list>
      </we-tab>
      <we-tab name="Finalizadas">
        <offers-list
          :offers-states="['finished', 'expired', 'cancelled', 'deserted']"
          :storeDestiny="'finishedList'"
          :filterType="'finishedNegotiations'"
          :negotiations="true"
          @click="loadListOffers"
          :ref="'finished'"
          :key="'finishedList'"
        >
        </offers-list>
      </we-tab>
    </we-tabs>
  </div>
</template>

<script>
import OffersList from "@/components/OffersList.vue";
import { mapState, mapMutations } from "vuex";
import gql from "graphql-tag";
import axios from "axios";
import { print } from "graphql";

axios.defaults.headers.common["referer-id"] =
  new Date().toLocaleString().replace(/[^\d]/g, "") +
  parseInt(Math.random() * 100000);

import WeTabs from "@/lib/WebExperto/components/WeTabs.vue";
import WeTab from "@/lib/WebExperto/components/WeTab.vue";

export default {
  components: {
    "offers-list": OffersList,
    "we-tabs": WeTabs,
    "we-tab": WeTab
  },
  methods: {
    loadListOffers(ref) {
      this.$refs[ref].getOffers();
    }
  }
};
</script>
